import * as R from 'ramda'

export const isActionType = R.propEq('type')
export const isActionOneOfTypes = R.compose(
  R.anyPass,
  R.map(type => isActionType(type))
)
